import dayjs from 'dayjs'
import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'
import { fillString } from '@local_modules/generic/string-template.js'

export function makeColumnDefs (entitiesResponse) {
  console.log('makeColumnDefs', entitiesResponse)

  const columnDefs = []

  columnDefs.push({
    field: 'name'
  })

  columnDefs.push({
    headerName: 'Zen Admin',
    valueGetter: function (cellParams) {
      return cellParams.data.id
    },
    cellRenderer: function (cellParams) {
      const url = fillString('/app/admin/entity/:accountingOrganisationId', {
        accountingOrganisationId: cellParams.value
      })
      return `<a href="${url}">View</a>`
    }
  })

  columnDefs.push({
    headerName: 'Xero',
    valueGetter: function (cellParams) {
      return makeXeroLink('Home', { shortCode: cellParams.data.xero_shortcode })
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.data.xero_shortcode) return null

      return '<a href="' + cellParams.value + '" target="_blank">Open</a>'
    }
  })

  columnDefs.push({
    headerName: 'Currency',
    field: 'base_currency'
  })

  columnDefs.push({
    headerName: 'Created',
    valueGetter: function (cellParams) {
      return cellParams.data.created_at
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null
      return dayjs(cellParams.value).format('D MMM YYYY @ HH:mm')
    }
  })

  columnDefs.push({
    headerName: 'Zenflow accounts',
    valueGetter: function (cellParams) {
      return cellParams.data.AppAccounts.length
    },
    valueFormatter: function (cellParams) {
      const appAccountNames = cellParams.data.AppAccounts.map(function (appAccount) {
        return `[${appAccount.name}]`
      })
      return appAccountNames.join(', ')
    }
  })

  columnDefs.push({
    headerName: 'Deleted',
    valueGetter: function (cellParams) {
      return cellParams.data.deleted_at
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null
      return dayjs(cellParams.value).format('D MMM YYYY @ HH:mm')
    }
  })

  columnDefs.push({
    headerName: 'Legal Name',
    field: 'name_legal'
  })

  return columnDefs
}
